import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
import { TOMOS } from '../data/tomos';
export function WhatsIncluded() {
  return <AnimatedSection id="contenido" className="relative bg-mist-200 py-10 sm:py-14 md:py-16 overflow-hidden" data-id="element-250" data-mp="3uaxa5z093uxh">
      {/* Editorial anatomical wash */}
      <div aria-hidden className="absolute -top-10 -right-16 w-[280px] h-[280px] rounded-full bg-petrol/[0.05] blur-3xl pointer-events-none" data-id="element-251" data-mp="pvnscs655v4o" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-252" data-mp="useenx8jhmyj">
        <div className="max-w-2xl mb-6 sm:mb-8" data-id="element-253" data-mp="gu7qj8te71c2">
          <div className="flex items-center gap-2 mb-2.5" data-id="element-254" data-mp="ltkclrcfw4dl">
            <span className="h-px w-6 bg-gold" data-id="element-255" data-mp="lrzi21q4klfq" />
            <span className="text-[9px] sm:text-[10.5px] font-bold tracking-[0.16em] uppercase text-petrol" data-id="element-256" data-mp="31kfa76utq9oa">
              La colección
            </span>
          </div>
          <h2 className="font-heading text-navy-950 tracking-tight text-[1.35rem] sm:text-[2.1rem] md:text-[2.4rem] leading-[1.14] mb-2" data-id="element-257" data-mp="36how4cj0837d">
            <span className="font-extrabold" data-id="element-258" data-mp="1rjdvf9vvmb32">6 tomos.</span>{' '}
            <span className="font-editorial italic text-gold-deep font-medium" data-id="element-259" data-mp="1rkymgpizfbw6">
              Un sistema clínico completo.
            </span>
          </h2>
          <p className="text-[13px] sm:text-[15.5px] text-navy-800/70 leading-relaxed" data-id="element-260" data-mp="21fz362za60al">
            Cada tomo aborda una parte diferente del razonamiento y la práctica
            clínica.
          </p>
        </div>

        {/* 2×3 on mobile · 3×2 on desktop — always all six visible */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-2.5 sm:gap-4 lg:gap-5" data-id="element-261" data-mp="2p5b82qnkrm73">
          {TOMOS.map((tomo, idx) => <motion.article key={tomo.n} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          delay: Math.min(idx, 3) * 0.04,
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="group" data-id="element-262" data-mp="2k81kzhnnrmmf" data-mpi={idx}>
              <div className="relative aspect-[3/4] rounded-lg sm:rounded-xl overflow-hidden bg-navy-950 shadow-[0_6px_20px_rgba(11,27,51,0.16)] group-hover:shadow-[0_12px_30px_rgba(11,27,51,0.24)] transition-shadow duration-300 ease-out" data-id="element-263" data-mp="3fxs3umr0cbae">
                <img src={tomo.cover} alt={tomo.coverAlt} width={600} height={800} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-264" data-mp="3owdmehwhbqb6" />
                <span className="absolute bottom-0 left-0 right-0 h-px bg-gold/40" data-id="element-265" data-mp="1zl4njf1wz9cg" />
              </div>

              <div className="pt-2 sm:pt-2.5" data-id="element-266" data-mp="24khas0wp6ifk">
                <div className={`inline-flex items-center gap-1.5 text-[8.5px] sm:text-[10px] font-bold tracking-[0.16em] uppercase mb-1 ${tomo.accent}`} data-id="element-267" data-mp="lniinmoakaxu">
                  <span className="h-px w-2.5 bg-current opacity-60" data-id="element-268" data-mp="cuf8bn8y0e7f" />
                  Tomo {tomo.n}
                </div>
                <h3 className="font-heading font-bold text-[12.5px] sm:text-[15px] text-navy-950 leading-tight mb-0.5" data-id="element-269" data-mp="7wwx1q7gdmw9">
                  {tomo.title}
                </h3>
                <p className="text-[10.5px] sm:text-[12.5px] text-navy-800/60 leading-snug" data-id="element-270" data-mp="10jzt8bonpljc">
                  {tomo.desc}
                </p>
              </div>
            </motion.article>)}
        </div>

        <div className="text-center mt-7 sm:mt-9" data-id="element-271" data-mp="qn4upssdvl52">
          <a href="#pricing" className="group inline-flex items-center justify-center gap-2 bg-navy-900 hover:bg-navy-800 text-white font-extrabold text-[13.5px] sm:text-base px-6 sm:px-8 py-3.5 sm:py-4 rounded-full transition-[transform,background-color] duration-200 ease-out hover:scale-[1.02] shadow-[0_10px_28px_rgba(11,27,51,0.2)] w-full max-w-[340px] sm:w-auto" data-id="element-272" data-mp="qopqtmucjc51">
            QUIERO LOS 6 TOMOS
            <ArrowRight size={16} className="text-gold group-hover:translate-x-1 transition-transform duration-200 ease-out" data-id="element-273" data-mp="u3puy5bjuuqa" />
          </a>
        </div>
      </div>
    </AnimatedSection>;
}